import { useEffect, useState } from "react";
import { Nav } from "@/components/Nav";
import { Footer } from "@/components/Footer";
import { GalleryGrid } from "@/components/GalleryGrid";
import { Reveal, Overline } from "@/components/Reveal";
import { api } from "@/lib/api";
import { PLACEHOLDER_GALLERY } from "@/data/content";
import { useLang, SERVICE_TITLE_EN } from "@/i18n";

const chipCls = (active) =>
  `px-6 py-2.5 text-xs uppercase tracking-[0.15em] border transition-colors duration-300 ${
    active ? "border-gold bg-gold text-black" : "border-white/20 text-white/60 hover:border-gold/60 hover:text-gold"
  }`;

export default function Galerie() {
  const [items, setItems] = useState(PLACEHOLDER_GALLERY);
  const [fromApi, setFromApi] = useState(false);
  const [typeFilter, setTypeFilter] = useState("all");
  const [prestationFilter, setPrestationFilter] = useState("all");
  const [prestations, setPrestations] = useState([]);
  const { t, lang } = useLang();

  useEffect(() => {
    api.get("/gallery")
      .then((res) => { if (res.data.length > 0) { setItems(res.data); setFromApi(true); } })
      .catch(() => {});
    api.get("/prestations").then((res) => setPrestations(res.data)).catch(() => {});
  }, []);

  const typeFilters = [
    { id: "all", label: t("ga.all") },
    { id: "image", label: t("ga.photos") },
    { id: "video", label: t("ga.videos") },
  ];

  const visible = items.filter(
    (i) =>
      (typeFilter === "all" || i.type === typeFilter) &&
      (prestationFilter === "all" || i.prestation === prestationFilter)
  );

  return (
    <div>
      <Nav />
      <main className="pt-36 pb-28 min-h-screen">
        <div className="max-w-7xl mx-auto px-6 lg:px-10">
          <Reveal>
            <Overline>{t("ov.galerie")}</Overline>
            <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl font-light tracking-tighter uppercase mb-6">
              {t("ga.h1")}
            </h1>
            <p className="text-white/60 max-w-xl leading-relaxed mb-12">
              {t("ga.sub")}
            </p>
          </Reveal>

          <Reveal delay={0.1} className="flex flex-wrap gap-3 mb-4">
            {typeFilters.map((f) => (
              <button key={f.id} data-testid={`filter-${f.id}`} onClick={() => setTypeFilter(f.id)} className={chipCls(typeFilter === f.id)}>
                {f.label}
              </button>
            ))}
          </Reveal>
          {prestations.length > 0 && (
            <Reveal delay={0.15} className="flex flex-wrap gap-2 mb-12" data-testid="prestation-filters">
              <button data-testid="filter-prestation-all" onClick={() => setPrestationFilter("all")} className={chipCls(prestationFilter === "all")}>
                {t("ga.allServ")}
              </button>
              {prestations.map((p) => (
                <button key={p.slug} data-testid={`filter-prestation-${p.slug}`}
                  onClick={() => setPrestationFilter(p.slug)} className={chipCls(prestationFilter === p.slug)}>
                  {lang === "en" ? SERVICE_TITLE_EN[p.title] || p.title : p.title}
                </button>
              ))}
            </Reveal>
          )}

          {visible.length === 0 ? (
            <p className="text-white/40 py-20 text-center" data-testid="gallery-empty">
              {t("ga.empty")}
            </p>
          ) : (
            <GalleryGrid items={visible} />
          )}
          {!fromApi && (
            <p className="mt-10 text-[11px] font-mono uppercase tracking-[0.2em] text-white/25">
              {t("ga.note")}
            </p>
          )}
        </div>
      </main>
      <Footer />
    </div>
  );
}
